import React from "react";
import { Box, Typography } from "@mui/material";

const BillingPageFrame = ({ title, subtitle, children, maxWidth, headerAction = null }) => (
    <Box sx={{ py: 2, width: "100%", maxWidth: maxWidth || "100%", boxSizing: "border-box" }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1 }}>
            <Box sx={{ minWidth: 0 }}>
                <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: "-0.02em", mb: 0.5 }}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {headerAction && <Box sx={{ flexShrink: 0 }}>{headerAction}</Box>}
        </Box>
        {children}
    </Box>
);

export default BillingPageFrame;
